import { useSyncExternalStore } from 'react';
import { PHONE_MAX_WIDTH } from '../phoneViewport';

const query = `(max-width: ${PHONE_MAX_WIDTH}px)`;
const snapshot = () => typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
const subscribe = (notify: () => void) => {
  if (typeof window.matchMedia !== 'function') return () => {};
  const media = window.matchMedia(query);
  media.addEventListener('change', notify);
  return () => media.removeEventListener('change', notify);
};
export function usePhoneTrackerLayout() {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
